import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
   name: 'appStatutesBorderBottom',
   standalone: true
})
export class AppStatutesBorderBottomPipe implements PipeTransform {
   transform(value?: number | null): string {
      if (!value) return 'border-b-app-gray-2'
      return this._iconsMap?.get(value) ?? 'border-b-app-gray-2'
   }

   private _iconsMap?: Map<number, string>

   constructor() {
      this._iconsMap = new Map<number, string>()
         .set(1, 'border-b-app-accent-1')
         .set(2, 'border-b-app-secondary-2')
         .set(3, 'border-b-app-secondary-2-light')
         .set(4, 'border-b-app-tertiary-1')
         .set(5, 'border-b-app-green-light')
         .set(6, 'border-b-app-secondary-2-verydark')
         .set(7, 'border-b-app-tertiary-3')
         .set(8, 'border-b-app-green')
         .set(9, 'border-b-app-secondary-3-dark')
         .set(10, 'border-b-app-tertiary-3')
         .set(11, 'border-b-app-secondary-2-verydark')
   }
}
